/** Trait names that can appear as emblems (Spatula / Frying Pan crafts). Matches admin meta comp editor. */
export const EMBLEM_TRAIT_NAMES: readonly string[] = [
  'Anima',
  'N.O.V.A.',
  'Dark Star',
  'Space Groove',
  'Meeple',
  'Stargazer',
  'Timebreaker',
  'Mecha',
  'Psionic',
  'Arbiter',
  'Primordian',
  'Rogue',
  'Challenger',
  'Brawler',
  'Vanguard',
  'Sniper',
  'Bastion',
  'Marauder',
  'Channeler',
  'Voyager',
  'Shepherd',
  'Replicator',
  'Fateweaver',
  'Redeemer',
]
